import axios from 'axios';
import { newClientRequestId, logClientEventToServer } from './clientLogApi.js';

// Configure axios to include credentials
axios.defaults.withCredentials = true;

// Use the proxy instead of the full URL
const API_URL = '/api';

/**
 * Extract data from a PDF application form
 * @param {File} file - The PDF file to extract data from
 * @returns {Promise<Object>} Extracted data with applicationId
 */
export const extractPdfData = async (file) => {
  const clientRequestId = newClientRequestId();
  void logClientEventToServer(
    'pdf_extract_started',
    { fileName: file.name, fileSize: file.size },
    clientRequestId
  );
  try {
    console.log('Uploading PDF for extraction:', file.name, 'Size:', file.size, clientRequestId);
    
    // Create form data
    const formData = new FormData();
    formData.append('pdf', file);
    
    // Send to backend
    const response = await axios.post(`${API_URL}/pdf/extract`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-Client-Request-Id': clientRequestId
      }
    });
    
    console.log('PDF extraction successful:', response.data);
    void logClientEventToServer('pdf_extract_success', { fileName: file.name }, clientRequestId);
    
    return response.data;
  } catch (error) {
    console.error('Error extracting PDF data:', error, clientRequestId);
    void logClientEventToServer(
      'pdf_extract_failed',
      {
        fileName: file?.name,
        message: error?.message,
        status: error?.response?.status
      },
      clientRequestId
    );
    
    // Return structured error
    if (error.response?.data) {
      throw new Error(error.response.data.message || 'Failed to extract data from PDF');
    }
    
    throw new Error('Failed to upload and extract PDF. Please try again.');
  }
};

export default {
  extractPdfData
};

